module.exports = __webpack_public_path__ + "img/mouth-head-neck-cancer-leaflet.542027b0.jpg";